import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";
import {
  AuthResponse,
  CreateAccountPayload,
  CreateTicketPayload,
  LoginPayload,
  UpdateProfilePayload,
} from "../types/auth.types";

export const signIn = async (payload: LoginPayload) => {
  const response = await axiosClient.post("/auth/user/login", payload);
  return response.data;
};

export const signInCoach = async (payload: LoginPayload) => {
  const response = await axiosClient.post("/auth/coach/login", payload);
  return response.data;
};

export const forgotPassword = async (email: string) => {
  const response = await axiosClient.post("/auth/forgot-pass", {
    email,
    is_user: 1, 
  });
  return response.data;
};

export const resetPassword = async (
  token: string,
  newPassword: string
) => {
  const response = await axiosClient.post("/auth/reset-pass", {
    token,
    newPassword,
  });

  return response.data;
};

export const getProfile = async () => {
  try {
    const response = await axiosClient.get<ApiResponse<AuthResponse>>("/user");
    return response.data;
  } catch (err) {
    console.warn("Error fetching profile : ", err);
    throw err;
  }
};

export const createAccount = async (payload: CreateAccountPayload) => {
  try {
    const formData = new FormData();

    formData.append("new_user", "0");

    if (payload.nickname) formData.append("nick_name", payload.nickname);

    // ✅ ADD BOTH
    if (payload.password) {
      formData.append("password", payload.password);
      formData.append("confirm_password", payload.confirmPassword);
    }

    formData.append(
      "demographic_data",
      JSON.stringify({
        age: payload.year,
        gender: payload.gender,
        race: payload.race,
      }),
    );

    const response = await axiosClient.post<ApiResponse<AuthResponse>>(
      "/user/edit",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    return response.data;
  } catch (err) {
    console.warn("Error creating account : ", err);
    throw err;
  }
};

export const updateProfile = async (
  payload: UpdateProfilePayload,
  imageFile?: File,
   is_image?: number,
) => {
  try {
    const formData = new FormData();

    if (imageFile) formData.append("image", imageFile);
   if (is_image !== undefined) {
  formData.append("is_image", String(is_image));
}

    if (payload.nickname) formData.append("nick_name", payload.nickname);
    if (payload.currentPassword)
      formData.append("current_password", payload.currentPassword);
    if (payload.confirmPassword)
      formData.append("confirm_password", payload.confirmPassword);

    formData.append(
      "demographic_data",
      JSON.stringify({
        age: payload.year,
        gender: payload.gender,
        race: payload.race,
      }),
    );

    const response = await axiosClient.post<ApiResponse<AuthResponse>>(
      "/user/edit",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating profile:", err);
    throw err;
  }
};

export const createTicket = async (payload: CreateTicketPayload) => {
  const response = await axiosClient.post<ApiResponse<any>>("/ticket", payload);
  console.log(response.data);
  return response.data;
};
